export default __webpack_public_path__ + "a73ca80aa4a10fbea61285f9ba4a5e43.png";